<div class="container-fluid" *ngIf="propiedades.id">

  <!-- Botón atrás -->
  <div class="back-button">
    <a [routerLink]="['/' + propiedades.tipoOperacion.code.toLowerCase()]" [queryParams]="{ view: lastView }">
      <i class="fas fa-arrow-circle-left"></i>
    </a>
  </div>

  <!-- Cabecera -->
  <h1 class="text-center">
    {{ propiedades.domicilio.calle }} {{ propiedades.domicilio.numero }}
    <span class="h4">, {{ propiedades.domicilio.barrio.localidad.descripcion }}</span>
  </h1>
  <hr />

  <div class="row g-3">
    <!-- Carrusel -->
    <div class="col-12 col-lg-8">
      <app-carousel [imagenes]="propiedades.imagenes" (imageClick)="openModal($event)" [showThumbs]="true">
      </app-carousel>
    </div>

    <!-- Lateral -->
    <div class="col-12 col-lg-4">
     <div class="card border-light mb-3 w-100">
        <div class="card-header bg-transparent">
            <div class="row g-3">
              <div class="col-6 col-lg-6">
                <h4>  
                  <span style="font-weight: 600; color: #df3230;">
                    {{ propiedades.tipoOperacion.descripcion }}
                  </span>
                  <ng-container *ngFor="let item of propiedades.caracteristicasPropiedad">
                    <span  *ngIf="item.code === 'APCRED'" class="aptCr-text">{{item.descripcion}}</span>
                  </ng-container>
                </h4>
              </div>
              <div class="col-6 col-lg-6">
                <ul class="social-icons">
                  <li>
                    <a *ngIf="propiedades.tipoOperacion.code === 'VENTA'" class="whatsaap"
                      href="https://api.whatsapp.com/send?phone=5493364528646&text= Hola, estoy interesado en la propiedad en {{propiedades.tipoOperacion.descripcion}} de {{propiedades.domicilio.calle}} {{propiedades.domicilio.numero}}."
                      target="_blank">
                      <i class="fab fa-whatsapp"></i>
                    </a>
                    <a *ngIf="propiedades.tipoOperacion.code === 'ALQUILER'" class="whatsaap"
                      href="https://api.whatsapp.com/send?phone=5493364521158&text= Hola, estoy interesado en la propiedad en {{propiedades.tipoOperacion.descripcion}} de {{propiedades.domicilio.calle}} {{propiedades.domicilio.numero}}."
                      target="_blank">
                      <i class="fab fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
          </div>
        </div>
      <!-- Descripción -->
      <div class="card-body">
        <h5 class="card-title">{{ propiedades.descripcionCorta }}</h5>

        <p class="card-text">
          <!-- Versión corta -->
          <span *ngIf="!showFullDescription">
            {{ propiedades.descripcionLarga | slice:0:200 }}...
          </span>

          <!-- Versión completa -->
          <span *ngIf="showFullDescription">
            {{ propiedades.descripcionLarga }}
          </span>
        </p>

        <button type="button" class="btn btn-link p-0" (click)="toggleDescription()">
          {{ showFullDescription ? 'Ver menos' : 'Ver más' }}
        </button>

        <h5 class="card-title text-end mt-3">
          <span *ngIf="propiedades.precio != 0" style="font-weight: 600; color: #df3230;">
            {{ propiedades.tipoMoneda.code === 'ARS' ? '$' : 'U$S' }}
            {{ propiedades.precio | number }}
          </span>
          <span *ngIf="propiedades.precio === 0" style="font-weight: 600; color: #df3230;">
            Consultar {{ propiedades.tipoMoneda.code === 'ARS' ? '$' : 'U$S' }}
          </span>
        </h5>
   
        </div>
        <div class="card-footer">
          <div class="row row-cols-6">
            <div
              class="col"
              *ngFor="let item of propiedades.caracteristicasPropiedad"
              [innerHtml]="item | iconspipe"
            ></div>
          </div>
        </div>
           </div>

      <!-- Ubicación -->
  <div class="card border-light mb-3" *ngIf="propiedades.domicilio?.lat && propiedades.domicilio?.lng">
    <div class="card-header bg-transparent">
      <h4>Ubicación</h4>
    </div>
    <div class="card-body text-center">
      <google-map [center]="center" [zoom]="zoom" height="150px" width="100%">
        <map-marker *ngIf="marker" [position]="marker" [icon]="markerIcon">
        </map-marker>
      </google-map>
    </div>
  </div>
      <!-- Video -->
      <div class="card border-light mb-3" *ngIf="propiedades.videoUrl">
        <div class="card-header bg-transparent">
          <h4>Video</h4>
        </div>
        <div class="card-body text-center">

          <!-- TikTok -->
          <ng-container *ngIf="propiedades.videoUrl.includes('tiktok.com')">
            <iframe [src]="sanitizeUrl('https://www.tiktok.com/embed/' + extractTikTokId(propiedades.videoUrl))"
              frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen class="w-100"
              style="min-height:500px">
            </iframe>

            <!-- Fallback por si el iframe falla -->
            <p class="mt-2">
              <a [href]="propiedades.videoUrl" target="_blank" rel="noopener noreferrer">
                Abrir en TikTok
              </a>
            </p>
          </ng-container>

          <!-- Instagram -->
          <iframe *ngIf="propiedades.videoUrl.includes('instagram.com')"
            [src]="sanitizeUrl(propiedades.videoUrl + '/embed')" frameborder="0"
            allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen class="w-100"
            style="min-height:400px">
          </iframe>

          <!-- YouTube -->
          <iframe *ngIf="propiedades.videoUrl.includes('youtube.com') || propiedades.videoUrl.includes('youtu.be')"
            [src]="sanitizeUrl(propiedades.videoUrl.replace('watch?v=', 'embed/'))" frameborder="0"
            allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen class="w-100"
            style="min-height:400px">
          </iframe>

        </div>
      </div>

    </div>
  </div>



</div>

<!-- Modal fullscreen -->
<div class="modal fade" id="carouselModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0 position-relative">

        <!-- Botón cerrar flotante -->
        <button type="button" class="close-floating" (click)="closeModal()">
          <i class="fas fa-times fa-2x"></i>
        </button>

        <!-- Carrusel fullscreen -->
        <div class="carousel-wrapper modal-wrapper" *ngIf="propiedades?.imagenes?.length">
          <!-- Principal -->
          <swiper-container class="main-swiper" thumbs-swiper=".thumbs-swiper-modal" slides-per-view="1"
            navigation="true" pagination="true" [initial-slide]="selectedIndex" autoplay-delay="3000"
            autoplay-disable-on-interaction="false">
            <swiper-slide *ngFor="let imagen of propiedades.imagenes">
              <img *ngIf="imagen?.imageData; else noImg" [src]="'data:image/jpeg;base64,' + imagen.imageData"
                class="modal-img" alt="imagen propiedad" />
              <ng-template #noImg>
                <img src="assets/no-imagen.jpg" class="modal-img" alt="sin imagen" />
              </ng-template>
            </swiper-slide>
          </swiper-container>

          <!-- Thumbnails debajo -->
          <swiper-container class="thumbs-swiper-modal" space-between="8" slides-per-view="6" free-mode="true"
            watch-slides-progress="true">
            <swiper-slide *ngFor="let imagen of propiedades.imagenes">
              <img *ngIf="imagen?.thumbnail; else noThumb" [src]="'data:image/jpeg;base64,' + imagen.thumbnail"
                class="thumb-img-horizontal" alt="miniatura" />
              <ng-template #noThumb>
                <img src="assets/no-imagen-thumb.jpg" class="thumb-img-horizontal" alt="miniatura vacía" />
              </ng-template>
            </swiper-slide>
          </swiper-container>
        </div>
      </div>
    </div>
  </div>
</div>